/* ... existing imports ... */
import React from 'react'
import { motion } from 'framer-motion'
import { format } from 'date-fns'
import SafeIcon from '../../common/SafeIcon'
import * as FiIcons from 'react-icons/fi'

const { FiTrendingUp, FiTrendingDown, FiEdit3, FiCalendar } = FiIcons

const TradesList = ({ trades, loading, onEditTrade }) => {
  if (loading) {
    return (
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
        <div className="flex items-center justify-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        </div>
      </div>
    )
  }

  if (trades.length === 0) {
    return (
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
        <div className="text-center text-gray-500">
          <p className="text-lg font-medium">No trades found</p>
          <p className="mt-1">Start by adding your first trade to track your performance</p>
        </div>
      </div>
    )
  }

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
      <div className="px-6 py-4 border-b border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900">Trade History</h3>
      </div>
      <div className="divide-y divide-gray-200">
        {trades.map((trade, index) => (
          <motion.div 
            key={trade.id} 
            initial={{ opacity: 0, y: 20 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ delay: index * 0.05 }} 
            className="p-6 hover:bg-gray-50 transition-colors"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <div className={`p-2 rounded-lg ${(trade.pnl || 0) >= 0 ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600'}`}>
                  <SafeIcon icon={(trade.pnl || 0) >= 0 ? FiTrendingUp : FiTrendingDown} className="h-5 w-5" />
                </div>
                <div>
                  <div className="flex items-center space-x-2">
                    <h4 className="text-lg font-semibold text-gray-900">
                      {trade.symbol} - {trade.side?.toUpperCase()}
                    </h4>
                    <span className={`px-2 py-1 rounded-full text-xs font-semibold ${(trade.pnl || 0) >= 0 ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                      {(trade.pnl || 0) >= 0 ? '+' : '-'}Rp {Math.abs(trade.pnl || 0).toLocaleString('id-ID')}
                    </span>
                  </div>
                  <div className="flex items-center space-x-4 mt-1 text-sm text-gray-500">
                    <div className="flex items-center space-x-1">
                      <SafeIcon icon={FiCalendar} className="h-4 w-4" />
                      <span>
                        {trade.entry_time ? format(new Date(trade.entry_time), 'MMM dd, yyyy HH:mm') : 'No date'}
                      </span>
                    </div>
                    {trade.setup_type && (
                      <span className="px-2 py-1 bg-blue-100 text-blue-800 rounded-md text-xs">
                        {trade.setup_type}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="flex items-center space-x-6">
                <div className="text-right">
                  <div className="text-sm text-gray-500">Entry/Exit</div>
                  <div className="font-medium">
                    {trade.entry_price ? trade.entry_price.toLocaleString('id-ID') : 'N/A'} / {trade.exit_price ? trade.exit_price.toLocaleString('id-ID') : 'N/A'}
                  </div>
                </div>
                <button onClick={() => onEditTrade(trade)} className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors">
                  <SafeIcon icon={FiEdit3} className="h-4 w-4" />
                </button>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  )
}

export default TradesList